import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../i18n/LanguageContext';
import './Footer.css';

const Footer = () => {
  const { t } = useLanguage();
  return (
    <footer className="site-footer">
      <Container>
        <Row>
          <Col md={4}>
            <ul className="footer-links">
              <li>
                <Link to="/hakkinda">{t('nav.about')}</Link>
              </li>
              <li>
                <Link to="/maddeler">{t('nav.entries')}</Link>
              </li>
              <li>
                <Link to="/yazarlar">{t('nav.authors')}</Link>
              </li>
              <li>
                <Link to="/gelismisArama">{t('nav.advancedSearch')}</Link>
              </li>
              <li>
                <Link to="/harita">{t('nav.map')}</Link>
              </li>
              <li>
                <Link to="/iletisim">{t('nav.contact')}</Link>
              </li>
            </ul>
          </Col>
          <Col md={4}>
            <ul className="footer-links">
              <li>
                <Link to="/hakkinda">{t('footer.aboutLong')}</Link>
              </li>
              <li>
                <Link to="/sorumluluk-reddi">{t('footer.disclaimer')}</Link>
              </li>
              <li>
                <Link to="/gizlilik-politikasi">{t('footer.privacy')}</Link>
              </li>
            </ul>
          </Col>
          <Col md={4}>
            <div className="footer-contact">
              <h3>{t('footer.contactHeading')}</h3>
              <p>
                <span>{t('footer.addressLabel')}</span>
                {t('footer.addressLine')}
              </p>
              <p>
                <span>{t('footer.phoneLabel')}</span> 0 (312) 284 34 18
              </p>
              <p>
                <span>{t('footer.emailLabel')}</span> tmkprojesi@akmb.gov.tr
              </p>
            </div>
          </Col>
        </Row>
        <div className="footer-bottom">
          <p>&copy; 2026 {t('footer.copyright')}</p>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
